<template>
  <base-form :title="$t('user.create.title')" @submit="submit">
    <div class="row justify-content-center">
      <div class="col-12">
        <fg-input :label="$t('generic.client')"
                  required
                  :error="getError($t('generic.client'))">
          <client-autocomplete v-model="model.client"
                               :name="$t('generic.client')"
                               v-validate:clientName="validations.client"
                               class="client-autocomplete">
          </client-autocomplete>
        </fg-input>
      </div>
      <div class="col-12">
        <fg-input :name="$t('user.create.step2.email')"
                  required
                  :placeholder="$t('user.create.step2.email')"
                  :label="$t('user.create.step2.email')"
                  v-model="model.email"
                  v-validate="validations.email"
                  :error="getError($t('user.create.step2.email'))"
                  addon-left-icon="nc-icon nc-email-85">
        </fg-input>
      </div>
      <div class="col-12">
        <fg-input :name="$t('user.create.step2.givenName')"
                  required
                  :placeholder="$t('user.create.step2.givenName')"
                  :label="$t('user.create.step2.givenName')"
                  v-model="model.given_name"
                  v-validate="validations.givenName"
                  :error="getError($t('user.create.step2.givenName'))"
                  addon-left-icon="nc-icon nc-circle-10">
        </fg-input>
      </div>
      <div class="col-12">
        <fg-input :label="$t('generic.site')"
                  required
                  :error="getError($t('generic.site'))">
          <site-autocomplete v-model="model.site"
                             :name="$t('generic.site')"
                             v-validate:siteName="validations.site">
          </site-autocomplete>
        </fg-input>
      </div>
    </div>
  </base-form>
</template>
<script>
  import SiteAutocomplete from 'src/components/Autocomplete/SiteAutocomplete'
  import ClientAutocomplete from 'src/components/Autocomplete/ClientAutocomplete'
  import ClientService from 'src/services/ClientService'

  export default {
    name: 'user-create-form',
    components: {
      SiteAutocomplete,
      ClientAutocomplete,
    },
    data () {
      return {
        model: {
          client: {},
          email: '',
          given_name: '',
          site: {}
        },
        validations: {
          email: {
            email: true,
            required: true
          },
          givenName: {
            required: true,
            min: 3
          },
          client: {
            required: true
          },
          site: {
            required: true
          }
        }
      }
    },
    computed: {
      clientName() {
        return this.model.client.name || '';
      },
      siteName() {
        return this.model.site.name || '';
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async submit () {
        let res = await this.$validator.validateAll()
        if (res) {
          this.$emit('submit', this.model)
        }
        return res
      }
    },
    async created () {
      let clientId = this.$route.query.client_uuid
      if (clientId) {
        let {data} = await ClientService.getById(clientId)
        this.model.client = data
      }
    }
  }
</script>
<style>
</style>
